import type { MDXRemoteSerializeResult } from 'next-mdx-remote';

export function isMarkdown(text: unknown): text is MDXRemoteSerializeResult {
	if (typeof text === 'object' && text !== null) {
		return Object.prototype.hasOwnProperty.call(text, 'compiledSource');
	}

	return false;
}
